import { createFileRoute } from "@tanstack/react-router";
import { LayoutDashboard, Sparkles } from "lucide-react";
import { seoHead } from "@/lib/seoHead";
import { SectionShell } from "@/components/admin/SectionShell";

const tabs = [
  { to: "/admin/ai", label: "Painel", icon: LayoutDashboard, exact: true },
  { to: "/admin/ai/sophia", label: "Sophia", icon: Sparkles },
];

export const Route = createFileRoute("/admin/ai")({
  head: () => seoHead({ title: "IA | Admin Shopping do Bem", description: "Área administrativa de inteligência artificial.", noindex: true }),
  component: AiLayout,
});

function AiLayout() {
  return <SectionShell title="IA" description="Ferramentas de inteligência artificial do Shopping do Bem" tabs={tabs} />;
}
